'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Rdio';

var EntypoRdio = function EntypoRdio(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M16.203,10.001c0,4.307-3.448,7.799-7.701,7.799S0.8,14.308,0.8,10.001C0.8,5.692,4.248,2.2,8.501,2.2c0.611,0,1.204,0.076,1.774,0.213v4.441c-0.902-0.33-2.01-0.281-3.053,0.223c-1.885,0.91-2.841,2.957-2.135,4.57c0.705,1.615,2.807,2.188,4.691,1.277c1.299-0.627,2.443-2.137,2.443-4.029V3.171c0.162,0.09,0.32,0.188,0.475,0.289c1.464,0.92,3.638,2.152,6.178,2.281c0.99,0.049-0.389,2.541-2.738,3.236C16.18,9.311,16.203,9.653,16.203,10.001z' })
    );
};

exports.default = EntypoRdio;
module.exports = exports['default'];